module.exports = __webpack_public_path__ + "img/PL00274.c7b3dd72.png";